module.exports = __webpack_public_path__ + "img/success.88fdc69c.png";